





























import {Vue, Component, Lifecycle, Prop, Trait, Watch, p} from 'av-ts'
import {Comparison, NumericCriteria} from '../deckard/models/search/NumericCriteria'

@Component
export default class NumericCriteriaInput extends Vue
{
    enteredNumber: number = 0;
    comparison: Comparison = "N/A";

    @Watch('enteredNumber')
    numberChange(newVal, oldVal)
    {
        this.$emit("input", this.generateCriteria());
    }

    @Watch('comparison')
    compareChange(newVal, oldVal)
    {
        this.$emit("input", this.generateCriteria());
    }

    generateCriteria(): NumericCriteria
    {
        let ret = new NumericCriteria();

        ret.value = this.enteredNumber;
        ret.comparison = this.comparison;

        return ret;
    }

    @Prop value:any = p(
    {
        type: NumericCriteria,
        required: true,
        default()
        {
            return new NumericCriteria();
        }
    })

    @Watch('value')
    valHandler(newVal, oldVal)
    {
        this.enteredNumber = this.value.value;
        this.comparison = this.value.comparison;
    }

    // lifecycle hook
    @Lifecycle mounted()
    {
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/NumericCriteriaInput.vue